import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import { pageTitle } from '../../helpers/PageTitle';
import { useNavigate } from 'react-router-dom';

export default function Portfolio1() {
  const navigate = useNavigate();

  const goToNext = () => {
    navigate('/portfolio/portfolio-2');
  };

  const goToPrev = () => {
    navigate('/portfolio/portfolio-4');
  };

  pageTitle('Karen Residence - Solar Flood Lights');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Solar Flood Light Installation"
        subTitle="Residential Project"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <div className="cs_portfolio_details">
          <img src="/images/portfolio/home-installation-1.jpg" alt="Flood Light Installation" />
          <Spacing lg="100" md="40" />
          <div className="cs_portfolio_details_in">
            <ul className="cs_portfolio_details_info cs_mp0">
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Client Type:</h3>
                <p className="mb-0">Private Residence</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
                <p className="mb-0">Karen, Nairobi</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Duration:</h3>
                <p className="mb-0">2 Weeks</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">
                  Project Completed:
                </h3>
                <p className="mb-0">March 2024</p>
              </li>
            </ul>
            <div className="cs_portfolio_details_right">
              <h2>Project Summary</h2>
              <p>
                This residential project involved the installation of high-efficiency solar flood lights across a private estate in Karen. The system was designed to provide comprehensive security lighting while maintaining the aesthetic appeal of the property.
                <br />
                The installation included state-of-the-art motion sensors and automated timing systems, ensuring optimal energy usage and security coverage.
              </p>
              <p>
                Key Features:
              </p>
              <ul>
                <li>Motion-activated LED flood lights</li>
                <li>Solar-powered battery backup system</li>
                <li>Smart control system with mobile app integration</li>
                <li>Weather-resistant installation</li>
                <li>Zero electricity bills for outdoor lighting</li>
              </ul>
            </div>
          </div>
          <Spacing lg="115" md="60" />
          <div className="cs_portfolio_details_gallery">
            <div>
              <img src="/images/portfolio/home-installation-2.jpg" alt="Night View" />
            </div>
            <div>
              <img src="/images/portfolio/home-installation-3.jpg" alt="Installation Process" />
            </div>
            <div>
              <img src="/images/portfolio/home-installation-4.jpg" alt="Control System" />
            </div>
          </div>
        </div>
        <Spacing lg="90" md="60" />
        <div className="cs_page_navigation cs_center">
          <div onClick={goToPrev} style={{ cursor: 'pointer' }}>
            <span className="cs_text_btn cs_type1">
              <Icon icon="cil:arrow-left" className="cs_fs_21" />
              <span>Prev Project</span>
            </span>
          </div>
          <div onClick={goToNext} style={{ cursor: 'pointer' }}>
            <span className="cs_text_btn">
              <span>Next Project</span>
              <Icon icon="cil:arrow-right" className="cs_fs_21" />
            </span>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
} 